import React from 'react';
import { withTitle } from '@blaze-cms/react-page-builder';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import getUrlTemplateToUse from './helpers/get-url-template-to-use';

const ProductTypes = dynamic(() =>
  import(/* webpackChunkName: "blazePbPpAggCardsProducTypes" */ './ProductTypes')
);

const Brands = dynamic(() => import(/* webpackChunkName: "blazePbPpAggCardsBrands" */ './Brands'));

const AggregationCards = ({ urlTemplate, entity, ...otherProps }) => {
  const router = useRouter();
  const urlTemplateToUse = getUrlTemplateToUse(urlTemplate, router);
  const { parent } = otherProps;
  const key = parent ? parent.itemId : ''; // used to rerender on parent/page change

  const TypeComponent = entity === 'brand' ? Brands : ProductTypes;
  return (
    <TypeComponent
      key={key}
      {...otherProps}
      urlTemplateToUse={urlTemplateToUse}
      urlTemplate={urlTemplate}
    />
  );
};

export default withTitle(AggregationCards);
